var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-treeview',{attrs:{"selectable":"","items":_vm.arrayFromMap(_vm.parentTagsOnly(_vm.tags)),"item-text":"name","item-key":"_id","label":"Tags","selection-type":"independent","value":_vm.tagFilters},on:{"input":_vm.onTagSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }